/* eslint-disable camelcase */
import { createContext, useContext } from 'react';

export const defaultLabels: IMitStudieTranslation = {
  navigation: {
    items: {
      overview: '',
      home: '',
      map: '',
    },
    sitename: '',
    items_language: '',
  },
  sign_in: {
    header: '',
    actions: {
      sign_in: '',
      mfa_setup: '',
    },
    intro: '',
    error: {
      header: '',
      text: '',
    },
    critical_error: {
      header: '',
      text: '',
    },
  },
  migration: {
    message: {
      header: '',
      text: '',
      button: '',
      subText: '',
    },
    modal: {
      header: '',
      text: '',
      list: {
        single_message_size_limit: '',
        mailbox_size_limit: '',
      },
      support_text: '',
      table: {
        current_mailbox_header: '',
        column_folder: '',
        column_message_count: '',
        column_size: '',
        column_subject: '',
        total: '',
        big_mail_header: '',
        message_count: '',
        size: '',
      },
      support: {
        link: '',
        text: '',
      },
    },
  },
  feeds: {
    error: {
      header: '',
      text: '',
    },
    empty_state: '',
    landing_page: {
      news: '',
      events: '',
    },
  },
  timetable: {
    heading: '',
    event_details: {
      description: '',
      form_and_group: '',
      instructor: {
        one: '',
        other: '',
      },
      lms_course: '',
      location: '',
      note: '',
      room: {
        one: '',
        other: '',
      },
      time: '',
    },
    modal: {
      actions: {
        exam: '',
        lms: '',
        roombooking: '',
        social: '',
      },
      types: {
        lms: '',
        exam: '',
        roombooking: '',
        social: '',
        teaching: '',
      },
    },
    toolbar: {
      next_week: '',
      previous_week: '',
      today: '',
      toggle: '',
    },
    callout: {
      no_event_this_week: {
        action: '',
        text: '',
      },
      no_future_events: {
        header: '',
        text: '',
      },
    },
    error: {
      generic: {
        header: '',
        text: '',
      },
      lms_link: {
        action: '',
        header: '',
        text: '',
      },
      action: {
        contact_it: '',
      },
      missing_content: {
        header: '',
        text: '',
      },
    },
    ical: {
      title: '',
      actions: {
        copy_link: '',
        generate_new_link: '',
      },
      disclaimer: '',
      intro: '',
      link_heading: '',
    },
    accessibility_week: '',
    weekSpan: '',
  },
  messages: {
    email: {
      heading: '',
      link: '',
      empty: '',
      migration: '',
    },
    lms: {
      link: '',
      heading: '',
      empty: '',
    },
  },
  student_overview: {
    timeline: {
      progress: {
        total_value: '',
        goal: '',
      },
      unit: '',
      course: {
        badge: {
          accessibility: {
            passed: '',
            failed: '',
          },
          exam: '',
          teaching: '',
          priority: '',
          pre_approved: '',
        },
        activity: {
          passed: '',
          failed: '',
          enrolled_course: '',
          and_exam: '',
          no_seat: '',
          for_course: '',
          for_exam: '',
          enrolled_exam: '',
          pre_passed: '',
          as_merit: '',
          priority: '',
          exam_attempt_one: '',
          exam_attempt_two: '',
          exam_attempt_tree: '',
          no_seat_break: '',
        },
        first_year: '',
        first_year_segment: '',
        priorities: '',
        modal: {
          status: '',
          scope: '',
          type: '',
        },
      },
      top: {
        time_limit_prescribed: '',
        time_limit_max: '',
        missing_exams: '',
        missing_limit: '',
      },
      semester: {
        spring: '',
        autumn: '',
        empty: '',
        name: '',
      },
      expand_programme: '',
      empty_state_semester: '',
      collapse_programme: '',
      transcript: {
        btn: '',
        header: '',
        paragraph1: '',
        paragraph2: '',
        language: {
          header: '',
          da: '',
          en: '',
        },
      },
      error: '',
      pre_semester: '',
      error_header: '',
      spring_semester: '',
      autumn_semester: '',
    },
    navigation: {
      diagramme: '',
      timeline: '',
      print_transcript: '',
      more: '',
    },
    course: {
      points: '',
      course_catalogue: '',
      course_catalogue_not_found: '',
      enrolled_courses: '',
      no_enrolled_courses: '',
      academic_regulation: '',
    },
    diagramme: {
      link_fallback: '',
      header: '',
      intro: '',
      academic_regulation_diagramme: '',
      academic_regulation_diagramme_text: '',
    },
    course_type: {
      compulsory: '',
      elective: '',
      supplementary: '',
      auxiliary: '',
    },
  },
  study_start: {
    actions: {
      dismiss: '',
    },
    header: '',
    text: '',
    days_left: {
      one: '',
      other: '',
    },
    modal: {
      actions: {
        confirm: '',
        cancel: '',
      },
      text: '',
    },
  },
  new_students: {
    intro: {
      header: '',
      text: '',
      summer_date: '',
      winter_date: '',
    },
    su: {
      text: {
        intro: '',
        before_applicationtime_date: '',
        before_applicationtime_month: '',
        su_winter_date: '',
        su_summer_date: '',
        start_month: {
          winter: '',
          summer: '',
        },
      },
      header: '',
      button: '',
    },
    student_card: {
      text: '',
      header: '',
    },
  },
  study_start_enrollment: {
    header: '',
    text: '',
  },
  study_start_enrollment_error: {
    header: '',
    text: '',
  },
  study_portal: {
    link: '',
    headings: {
      news: '',
      events: '',
    },
    heading: '',
    toolbar: {
      portal_option: '',
      toggle: '',
    },
  },
  generics: {
    navigation: {
      local: {
        toggle: '',
      },
      global: {
        toggle: '',
      },
    },
    sub_nav: {
      profile_settings: '',
      toggle_not_signed_in: '',
      switch_language: '',
      toggle_aria_label: '',
      change_language: '',
      change_password: '',
      notifications: {
        subject_passed: '',
        mark_as_read: '',
        subject_failed: '',
        empty: '',
        header: '',
      },
    },
    modal: {
      close: '',
    },
    callout: {
      text: {
        try_again: '',
      },
    },
    authentication: {
      sign_out: '',
      sign_in: '',
    },
    user: {
      au_id: '',
      student_registration_number: '',
      copy_student_number: '',
      copy_auid: '',
    },
    actions: {
      save: '',
      cancel: '',
      edit: '',
    },
    validation: {
      confirmed: '',
    },
    toolbar: {
      toggle: '',
    },
    accessibility: {
      horizontal_scroll: {
        keyboard_instructions: '',
        forward: '',
        backward: '',
      },
      stepper: {
        header: {
          with_procesname: '',
          no_procesname: '',
        },
      },
    },
    page_error: {
      header: '',
      text: '',
    },
    copy_to_clipboard: {
      copied: '',
      label_prefix: '',
    },
    forms: {
      character_count: {
        overflow: {
          message: {
            recommended: '',
            allowed: '',
          },
          count: {
            recommended: {
              one: '',
              other: '',
            },
            allowed: {
              one: '',
              other: '',
            },
          },
        },
        count_down: {
          one: '',
          other: '',
        },
      },
    },
  },
  footer: {
    compliance: {
      accessibility: '',
      cookies: '',
      privacy: '',
    },
    support: {
      technical: {
        link: '',
        heading: '',
        text: '',
      },
      counselling: {
        text: '',
        heading: '',
        link: '',
      },
    },
  },
  impersonation: {
    label: '',
    input_label: '',
    activated_header: '',
    activated_text: '',
    screenreader_header: '',
    select: {
      label: '',
      option_cpr: '',
      option_email: '',
    },
    button: {
      confirm: '',
      abort: '',
      hide: '',
      show: '',
    },
    error: {
      lms_text: '',
      email_text: '',
      header: '',
    },
    select_student: '',
    select_student_error: '',
  },
  student_card: {
    studentCard: '',
    orderNewStudentCard: '',
    lostYourCard: '',
    orderANewCard: '',
    changePincode: '',
    orderNewPincodeAt: '',
    getBuildingAccess: '',
    activateStudentCardAsAccessCard: '',
    onlyValidWithConfirmation: '',
    youCanPrintOne: '',
    noAccessHeader: '',
    noAccess: '',
    stadsLinkText: '',
    photoRequirements: '',
    jpgFormat: '',
    maxSize: '',
    mustBeValidPhotoLike: '',
    passportPhoto: '',
    needHelp: '',
    writeTo: '',
    noteOtherUses: '',
    readmore: '',
    submitNew: '',
    submit: '',
    thanksForSubmitting: '',
    willBeSent: '',
    okGoBack: '',
    errorSubmitting: '',
    mustBeJpg: '',
    mustBeMaxSize: '',
    yourPhoto: '',
    chooseAnImage: '',
    uploadNewImage: '',
    studentNumber: '',
    lastOrderDate: '',
    errorHeader: '',
    errorBody: '',
    back: '',
    loginWelcome: '',
    disabledText: '',
    disabledHeader: '',
    save: '',
    saveConsent: '',
  },
};

export const importJson = <T>(filename: string, lang: string): Promise<T> => import(`../i18n/${lang}/${filename}.json`);

export const TranslationsContext = createContext<IMitStudieTranslation>(defaultLabels);
// eslint-disable-next-line max-len
export const useTranslationsContext = (): IMitStudieTranslation => useContext(TranslationsContext);
